import React from 'react';

export default (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="32" cy="32" r="30" stroke="#5FCB8A" strokeWidth="4"/>
        <path d="M21.8184 31.6364L31.6365 41.4545L48.0911 25" stroke="#5FCB8A" strokeWidth="4" strokeLinecap="round"/>
    </svg>
);